var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbAudi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.359,
    height: 33.359,
    viewBox: "0 0 33.359 33.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Facebook",
    d: "M217.818,193.359H201.842A1.842,1.842,0,0,1,200,191.518V161.842A1.841,1.841,0,0,1,201.843,160h29.677a1.841,1.841,0,0,1,1.841,1.842v29.676a1.842,1.842,0,0,1-1.841,1.842h-8.5V180.441h4.337l.649-5.035h-4.986v-3.214c0-1.458.405-2.451,2.495-2.451h2.666v-4.5a35.715,35.715,0,0,0-3.885-.2c-3.843,0-6.475,2.346-6.475,6.654v3.713h-4.347v5.035h4.347v12.918Z",
    transform: "translate(-200.001 -160)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbAudi);
export default __webpack_public_path__ + "static/media/Fb_audi.ad32e369f40234850b70156a94f01959.svg";
export { ForwardRef as ReactComponent };